import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { IParameter } from 'models/parameter';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  loading: boolean;
  parameter: IParameter;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const EditParameter: React.FC<Props> = ({ open, loading, parameter, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation();

  let basicFields: IFormField[] = [
    {
      name: 'name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name'),
      defaultValue: parameter.name,
      internalLabel: true,
      required: true
    },
    {
      name: 'value',
      label: t('T_value'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_value'),
      defaultValue: parameter.value,
      internalLabel: true,
      required: true
    },
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_parameter') || 'Edit Parameter'}
      maxWidth="lg"
      children={
        <Stack spacing={2} p={2}>
          <Form fields={basicFields} onChange={onChanges} />
        </Stack>
      }
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1}>
          <MuiButton
            variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large'
            onClick={onClose}
          >
            {t('T_cancel')}
          </MuiButton>
          <MuiButton
            variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large'
            onClick={onSubmit}
          >
            {t('T_update') || 'Update'}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>
        </Grid>
      }
    />
  );
};

export default EditParameter;

